import { Component, OnInit } from '@angular/core';
import { DialogService } from '../../services/dialog.service';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss'],
  animations: [
    // Your animations here
  ]
})
export class DialogComponent implements OnInit {

  constructor(public dialogService: DialogService) { }

  ngOnInit(): void {}

  // This method is called when the confirm button is pressed
  onConfirm(): void {
    if (this.dialogService.confirmAction) {
      this.dialogService.confirmAction();  // Call the passed-in function
    }
    this.dialogService.hideDialog();  // Optionally hide the dialog after confirmation
  }
}
